module.exports = __webpack_public_path__ + "static/media/city.db2bf4cd.svg";